import { Box, Typography } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { If } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { InlineCompareButtons } from "routes/schedule/compare/inline-approval-buttons/inline-compare-buttons"
import { AuthoringReviewAmendsBlock } from "./authoring-review-amends-block"
import { AuthoringReviewPriorRejection } from "./authoring-review-prior-rejection"
import { normalizeAuthoringComparisonText } from "./lib/authoring-comparison-normalization"
import { AuthoringSideBySideRow } from "./authoring-side-by-side-row"

export function AuthoringReviewSideBySideDetailsRow({ field, label, acceptId, idFromGroup, amendsKey, subtitle }) {
    const { compare, target, comparisonTarget } = useBoundContext()
    const hasDifference =
        normalizeAuthoringComparisonText(compare?.[field]) !==
        normalizeAuthoringComparisonText(comparisonTarget?.[field])

    return (
        <Bound acceptId={acceptId} showEditor={true} hideUpBar={true} hideToolbar={true}>
            <AuthoringSideBySideRow
                left={
                    <DetailsFieldValue label={label} value={target?.[field]} dataCy={`side-by-side-details-${field}`} />
                }
                right={
                    <DetailsFieldValue
                        label={label}
                        value={comparisonTarget?.[field]}
                        dataCy={`side-by-side-details-${field}-comparison`}
                    />
                }
                after={
                    hasDifference ? (
                        <Box className="after" ml={4} mb={1}>
                            <InlineCompareButtons idFromGroup={idFromGroup} to={target} from={comparisonTarget} />
                        </Box>
                    ) : null
                }
                below={
                    <>
                        <AuthoringReviewPriorRejection amendsKey={amendsKey} />
                        <If truthy={hasDifference}>
                            <AuthoringReviewAmendsBlock
                                amendsKey={amendsKey}
                                subtitle={subtitle}
                                cyPrefix="side-by-side-amends"
                            />
                        </If>
                    </>
                }
            />
        </Bound>
    )
}

function DetailsFieldValue({ label, value, dataCy }) {
    return (
        <Box py={1.5} data-cy={dataCy}>
            <Typography variant="overline">{label}</Typography>
            <Typography variant="h5">{value}</Typography>
        </Box>
    )
}
